import Vue from 'vue';

Vue.filter('categories', (value: any) => {
  if (!value) {
    return '<n/a>';
  }
  return value.join(', ');
});
